import { render, staticRenderFns } from "./UIRadioGroup.vue?vue&type=template&id=76843442&scoped=true"
import script from "./UIRadioGroup.vue?vue&type=script&lang=js"
export * from "./UIRadioGroup.vue?vue&type=script&lang=js"
import style0 from "./UIRadioGroup.vue?vue&type=style&index=0&id=76843442&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76843442",
  null
  
)

export default component.exports